import { Component, OnInit, ViewChild, HostListener, OnDestroy } from "@angular/core";
import { Table } from "primeng/table";
import { UserWalletRedemptionService } from "src/app/services/userWalletRedemption.service";
import { Router } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { TitleCasePipe } from "@angular/common";
import { LazyLoadEvent } from "primeng/api";
import { Dropdown } from "primeng/dropdown";
import { environment } from "src/environments/environment";
import { saveAs } from "file-saver/src/FileSaver";
import * as moment from "moment";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SubscribeService } from "src/app/frontend/service/subscribeService.service"
import {v4 as uuidv4} from 'uuid';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface PaymentMethod {
  name: string,
}

@Component({
  templateUrl: "./walletRedemptionRequest.component.html",
  styleUrls: ["./walletRedemptionRequest.component.scss"],
  styles: [
    `
      :host ::ng-deep .p-datatable-gridlines p-progressBar {
        width: 100%;
      }

      @media screen and (max-width: 960px) {
        :host
          ::ng-deep
          .p-datatable.p-datatable-customers.rowexpand-table
          .p-datatable-tbody
          > tr
          > td:nth-child(6) {
          display: flex;
        }
      }
    `,
  ],
  providers: [MessageService, ConfirmationService, TitleCasePipe],
})

export class WalletRedemptionRequest implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  methods: PaymentMethod[];
  idempotencyKey = uuidv4();
  selectedMethod: PaymentMethod;
  errorMessage = "";
  statuses: any[];
  searchBy: any[];
  paymentType: boolean = false;
  paymentReject: boolean = false;
  totalRecords: 0;
  walletlist: any;
  public item: any[] = [];
  loading: boolean;
  paginationOption;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  calvalue: Date;
  ucalvalue: Date;
  dcalvalue: Date;
  yearRange;
  minYear = environment.minYear;
  startDate: Date;
  endDate: Date;
  downloadFlg: boolean;
  downloadwalletlist: any;
  searchby;
  wdcalvalue;
  paymentImage;
  paymentMethod;
  comment;
  requestedDate;
  public hide: boolean = true;
  public sellerCsvFile;
  approveUpdateForm: FormGroup;
  rejectUpdateForm: FormGroup;
  submitted: boolean = false;
  uploadedFiles: any[] = [];
  public imageProfile;
  redemptionData;
  showProfile = false;
  displayBasic: boolean | undefined;
  public showHighlightImg = "";
  responsiveOptions: any[] = [
    {
      breakpoint: '1500px',
      numVisible: 5
    },
    {
      breakpoint: '1024px',
      numVisible: 3
    },
    {
      breakpoint: '768px',
      numVisible: 2
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  public disabled: boolean = false;
  userRedemptionId: any;
  dataPresent: boolean = true;
  rsubmitted: boolean= false;

  constructor(private userWalletRedemptionService: UserWalletRedemptionService, private router: Router, private messageService: MessageService, private confirmationService: ConfirmationService, private formBuilder: FormBuilder, private subscribeservice: SubscribeService) {
    this.methods = [
      { name: 'Online Payment' },
      { name: 'Cash' },
      { name: 'Credit Card' },
      { name: 'Debit Card' },
      { name: 'Bank Transfer' },
      { name: 'Cheque' },
      { name: 'Direct Deposit' },
      { name: 'Mobile Payment' },
      { name: 'Cryptocurrency' },
      { name: 'Electronic Funds Transfer (EFT)' },
      { name: 'Money Order' },
    ];
  }

  ngOnInit() {
    this.paginationOption = environment.pagination;
    this.statuses = [
      { label: "Pending", value: "Pending" },
      { label: "Approved", value: "Approved" },
      { label: "Rejected", value: "Rejected" },
      { label: "Bank Auto Withdraw", value: "Bank Auto Withdraw" }
    ];
    this.searchBy = [
      { label: "Requested On", value: "created_at" }
    ];
    this.downloadFlg = false;
    this.approveUpdateForm = this.formBuilder.group(
    {
      paymentMethod: ["", { validators: [Validators.required], updateOn: "blur" }],
      comment: [""],
    });
    this.rejectUpdateForm = this.formBuilder.group(
    {
      comment: ["", { validators: [Validators.required], updateOn: "blur"}]
    });
  }

  get f() {
    return this.approveUpdateForm.controls;
  }

  get h() {
    return this.rejectUpdateForm.controls;
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = "";
    this.dt.filter("", "userName", "contains");
    this.dt.filter("", "created_at", "dateIs");
    this.dt.filter("", "transferAmount", "contains");
    this.dt.filter("", "tds", "contains");
    this.dt.filter("", "commission", "contains");
    this.dt.filter("", "totalCreditedAmount", "contains");
    this.dt.filter("", "bankName", "contains");
    this.dt.filter("", "accountNumber", "contains");
    this.calvalue = null;
    this.ucalvalue = null;
    this.dcalvalue = null;
    this.wdcalvalue = null;
    this.pDropDownId.clear(null);
    if (this.pDropDownId) {
      this.pDropDownId.value = null;
    }
  }

  loadWallet(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
   // var query = "?filterByDisable=false&filterByRollName=player";
    var query = "?filterByDisable=false&showAll=true";
    var pagenumber = 1;
    var params = "";
    var rows;
    this.subscribeservice._pendingReq.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if(res && event.filters["status"] == undefined){
        params+=res
      }
    });
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }
    if (
      this.searchby != undefined &&
      this.startDate != undefined &&
      this.endDate != undefined
    ) {
      params += "&filterByDate=" + this.searchby.value;
      params +=
        "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    if (event.filters != undefined && event.filters["userName"] != undefined) {
      params += "&filterByname=" + event.filters["userName"].value;
    }
    if (
      event.filters != undefined &&
      event.filters["created_at"] != undefined
    ) {
      const created_at = moment(event.filters["created_at"].value).format(
        "YYYY-MM-DD"
      );
      params += "&filterByCreatedAt=" + created_at;
    }
    if (event.filters != undefined && event.filters["transferAmount"] != undefined) {
      params += "&filterByTransferAmmount=" + event.filters["transferAmount"].value;
    }
    if (event.filters != undefined && event.filters["tds"] != undefined) {
      params += "&filterByTds=" + event.filters["tds"].value;
    }
    if (event.filters != undefined && event.filters["commission"] != undefined) {
      params += "&filterByCommission=" + event.filters["commission"].value;
    }
    if (event.filters != undefined && event.filters["totalCreditedAmount"] != undefined) {
      params += "&filterByTotalCreditedAmount=" + event.filters["totalCreditedAmount"].value;
    }
    if (event.filters != undefined && event.filters["bankName"] != undefined) {
      params += "&filterByBankName=" + event.filters["bankName"].value;
    }
    if (event.filters != undefined && event.filters["accountNumber"] != undefined) {
      params += "&filterByAccountNumber=" + event.filters["accountNumber"].value;
    }
    if (event.filters != undefined && event.filters["status"] != undefined) {
      params += "&filterByStatus=" + event.filters["status"].value;
    }
   
    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.userWalletRedemptionService.getList(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.loading = false;
        if (this.downloadFlg === true) {
          this.exportExcelsheet(data.data.items);
        } else {
        this.walletlist = data.data.items;
        this.totalRecords = data.data.totalCount;
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  editWallet(id) { }

  removeFile(event) {
    this.uploadedFiles = [];
    this.paymentImage = "{{imageProfile}}";
  }
  
  picUploader(event) {
    for (let file of event.files) {
      this.uploadedFiles.push(file);
      var reader = new FileReader();
      reader.readAsDataURL(this.uploadedFiles[0]);
      reader.onload = () => {
        // called once readAsDataURL is completed
        this.paymentImage = reader.result;
      };
    }
  }
  onPaymentMethodSelect(event) {
    this.paymentMethod = undefined;
    if (event.value) {
      this.paymentMethod = event.value.name;
    }
  }
  approveuser() {
    this.submitted = true;

    if (this.approveUpdateForm.invalid) {
      return;
    }
    this.confirmationService.confirm({
        message: `
          <h4 style="margin:0;">Are you sure?</h4>
          <p style="margin-top:10px;">
              You want to change this status ?
          </p>
        `,
        acceptLabel: 'Confirm',
        rejectLabel: 'Cancel',

      //message: "Are you sure you want to change the status to Approved",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {

        let updateData = this.approveUpdateForm.value;

        updateData["paymentImage"] = this.paymentImage;
        updateData["paymentMethod"] = this.selectedMethod.name;
        updateData["approved"] = true;

        this.userWalletRedemptionService
          .adminupdatestatus(this.userRedemptionId, updateData,this.idempotencyKey).pipe(takeUntil(this.destroy$))
          .subscribe(
            (data) => {
              this.messageService.add({
                key: "toastmsg",
                severity: "success",
                summary: "Successful",
                detail: "Wallet Status Updated",
                life: 3000,
              });
              //this.getUserDetails(data.id);
              this.router.routeReuseStrategy.shouldReuseRoute = () => false;
              this.router.onSameUrlNavigation = "reload";
              this.router.navigate(["/manage/report/wallet/redemption"]);
              this.userRedemptionId = null

            },
            (err) => { }
          );
      },
      reject: () => {
        //this.getUserDetails(data.id);
      },
    });
    // }
  }
  rejectuser() {
    this.rsubmitted = true;
    if (this.rejectUpdateForm.invalid) {
      return;
    }
    this.confirmationService.confirm({
      message: "Are you sure you want to change the status to Rejected",

      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        let updateData = this.rejectUpdateForm.value;

        updateData["rejected"] = true;
        this.userWalletRedemptionService
          .updatestatus(this.userRedemptionId, updateData).pipe(takeUntil(this.destroy$))
          .subscribe(
            (data) => {

              this.messageService.add({
                key: "toastmsg",
                severity: "success",
                summary: "Successful",
                detail: "Wallet Status Updated",
                life: 3000,
              });
              //this.getUserDetails(data.id);
              this.router.routeReuseStrategy.shouldReuseRoute = () => false;
              this.router.onSameUrlNavigation = "reload";
              this.router.navigate(["/manage/report/wallet/redemption"]);
              this.userRedemptionId = null
            },
            (err) => {
              this.errorMessage = err.error.message;
            }
          );
      },
      reject: () => {
        //this.getUserDetails(data.id);
      },
    });
    // }
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadWallet(this.lastTableLazyLoadEvent);
  }
  exportExcelsheet(walletlist) {
    // this.downloadFlg = true;
    // this.loadWallet(this.lastTableLazyLoadEvent);
    var propertiesRemove = [
      "id",
      "created_at",
      "createdby",
      "updatedby",
      "disable",
      "updated_at",
      //"status",
      "created_by",
      "Modification_Date",
    ];
    this.downloadwalletlist = walletlist;
    this.downloadwalletlist.forEach(function (item) {
      if (item.updated_at != "") {
        item["Modification_Date"] = moment(item.updated_at).format(
          "DD/MM/YYYY"
        );
      }
      propertiesRemove.forEach(function (prop) {
        delete item[prop];
      });
    });
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(this.downloadwalletlist);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "user_redemption");
    });
    this.downloadFlg = false;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  /**
   * Use to add more columns in the table.
   */
  addColumns() {
    this.hide = false;
  }

  /**
   * Use to remove more columns in the table.
   */
  removeColumns() {
    this.hide = true;
  }
  getClassOf(status) {
    if (status == "Approved" || status === "Bank Auto Withdraw") {
      return "bg-success text-white";
    } else if (status == "Pending") {
      return "bg-warning text-dark";
    } else {
      return "bg-danger text-white";
    }
  }

  showPaymentmodal(id, data) {
    this.paymentType = true;
    this.userRedemptionId = id
    this.redemptionData = data
    if (data == "view") {
      this.viewPaymentDetails(id)
    }
  }
  showPaymentrejectmodal(id, data) {
    this.userRedemptionId = id
    this.paymentReject = true;
    this.redemptionData = data
    if (data == "view") {
      this.viewPaymentDetails(id)
    }
  }
  viewPaymentDetails(redemptionId) {
    var query = "?filterByDisable=false&filterById=" + redemptionId;
    this.userWalletRedemptionService.getList(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.item = data.data.items
        if (this.item[0].status == "Pending") {
          this.dataPresent = true
        } else {
          this.dataPresent = false
        }

        if (this.item[0]["paymentMethod"]) {
          this.selectedMethod = { name: this.item[0]["paymentMethod"] }
        }
        this.approveUpdateForm.patchValue({
          comment: this.item[0]["comment"],
        });
        this.rejectUpdateForm.patchValue({
          comment: this.item[0]["comment"],
        });
        if (this.item[0]["paymentImage"] != undefined) {
          this.imageProfile = this.item[0]["paymentImage"];

          this.showProfile = true;
        } else {
          this.showProfile = false;
        }
        this.approveUpdateForm.get("paymentMethod").disable();
        this.rejectUpdateForm.get("comment").disable();
        this.approveUpdateForm.get("comment").disable();

      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  public openHightlightImage() {
    this.displayBasic = true

    this.showHighlightImg = this.item[0]["paymentImage"];
  }
  @HostListener('window:keyup.esc', ['$event']) w(e: KeyboardEvent) {
    this.displayBasic = false;
  }

  onPaymentmodalModalClose() {
    this.approveUpdateForm.reset();
    this.rejectUpdateForm.reset();
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    // this.router.onSameUrlNavigation = "reload";
    // this.router.navigate(["/manage/report/wallet/redemption"]);

  }

  ngOnDestroy() {
    this.subscribeservice.pendingReqData(null);
    this.destroy$.next();
    this.destroy$.complete();
  }
}
